import React, {useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import AddNewSharedNumber from './modal/AddNewSharedNumber'
import EditSharedNumber from './modal/EditSharedNumber'
import NodataYet from '../../../Components/NodataYet'
import {
  useDeleteSharedNumberMutation,
  useGetSharedNumberListQuery,
} from '../../../../services/cellcast'
import ReactPaginate from 'react-paginate'
import {toast} from 'react-toastify'
import {useLoadedData} from '../../../hooks/useGetLoadedData'

const SharedNumberList = () => {
  const [showSharedNumber, setShowSharedNumber] = useState(false)
  const [editNumber, setEditNumber] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [editNumberData, setEditNumberData] = useState<any>({
    country: {value: 'au', label: 'Australia'},
  })
  const [deleteIds, setDeleteIds] = useState<any>()
  const {calculate, loadedData, setLoadedData} = useLoadedData()

  const [page, setPage] = useState<any>({
    page: 1,
    size: 10,
    searchKey: '',
    availability: '',
    status: '',
    billingStatus: '',
  })

  const debouncedSearchTerm = useDebounce(page?.searchKey, 3000)

  /////////////////////////////////////USE-EFFECT//////////////////////////////////////
  const {
    data: sharedNumberData,
    refetch,
    isFetching,
    isLoading: isLoadingSharedNumber,
  } = useGetSharedNumberListQuery(page)

  const [deleteSharedNumber] = useDeleteSharedNumberMutation()

  useEffect(() => {
    refetch()
  }, [debouncedSearchTerm, page.page, page.size, refetch])

  useEffect(() => {
    if (sharedNumberData?.data && sharedNumberData?.data?.total) {
      const calculatedData = calculate(page.page, page.size, sharedNumberData?.data?.total)
      setLoadedData(calculatedData)
    }
  }, [sharedNumberData, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      deleteSharedNumber({id: deleteIds})
        .unwrap()
        .then((res) => {
          toast.success(res.message)
        })
        .catch()
        .finally(() => {
          setDeleteIds('')
          setConfirm(false)
          refetch()
        })
    }
  }, [confirm, deleteIds])

  /////////////////////////////////use-MEMO//////////////////////////////////////

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this shared number?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const SNPopup = useMemo(
    () => (
      <AddNewSharedNumber
        show={showSharedNumber}
        handleClose={() => setShowSharedNumber(false)}
        refetch={refetch}
      />
    ),
    [showSharedNumber]
  )

  const editSNnumber = useMemo(
    () => (
      <EditSharedNumber
        data={editNumberData}
        setData={setEditNumberData}
        show={editNumber}
        handleClose={() => setEditNumber(false)}
        refetch={refetch}
      />
    ),
    [editNumber, editNumberData]
  )
  ///////////////////////////////////ALL Function //////////////////////////////

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  const handlePageChange = (newPage: number) => {
    setPage({...page, page: newPage})
  }

  return (
    <>
      {SNPopup}
      {editSNnumber}
      {confirmation}
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search shared number'
                value={page?.searchKey}
                onChange={(e) => setPage({...page, searchKey: e.target.value})}
              />
            </div>
          </div>
          <div className='card-toolbar m-0'>
            <div className='d-flex gap-3 align-items-center'>
              <button className='btn btn-primary' onClick={() => setShowSharedNumber(true)}>
                Create
              </button>
            </div>
          </div>
        </div>

        {isLoadingSharedNumber || isFetching ? (
          <div className='row flex-center h-300 mb-10'>
            <Spinner />
          </div>
        ) : sharedNumberData && sharedNumberData?.data?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Number</th>
                      <th>Type</th>
                      <th>Gateway</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {sharedNumberData?.data?.items?.map((val: any, id: number) => (
                      <tr key={id}>
                        <td>{val?.number}</td>
                        <td>
                          <span
                            className={`${
                              val?.gatewayProvider?.type == 'SMS'
                                ? 'badge badge-light-success '
                                : 'badge badge-light-info'
                            }`}
                          >
                            {val?.type}
                          </span>
                        </td>
                        <td>
                          {val?.gatewayProvider?.DB} - {val?.gatewayProvider?.gatewayName}
                        </td>

                        <td className='text-end'>
                          <span
                            onClick={() => {
                              const editData = {
                                _id: val?._id,
                                number: val?.number,
                                gateway: val?.gatewayProvider?._id,
                                type: val?.type,
                              }

                              setEditNumber(true)
                              setEditNumberData({...editData})
                            }}
                            className='btn btn-bg-light btn-active-color-primary btn-sm'
                          >
                            Edit
                          </span>
                          <span
                            onClick={() => handleDelete(val?._id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen027.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='abcd'>
                <select
                  onChange={(e) => {
                    setPage({...page, size: e.target.value})
                  }}
                  value={page.size}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                Show {loadedData.startLoad} - {loadedData.endLoad} of{' '}
                {sharedNumberData?.data?.total}
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={sharedNumberData?.data?.totalPages}
                  onPageChange={(e) => {
                    handlePageChange(e.selected + 1)
                  }}
                  containerClassName={'pagination'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default SharedNumberList
